const $hero = document.querySelectorAll('.ft-Hero__slide ul li');

window.addEventListener('load', () => {

  $hero.forEach((value, index) => {
    setTimeout(() => {
      value.classList.add('is-show');
    }, 500 * index);
  });
});
